module.exports = __webpack_public_path__ + "img/country-select-thick.13797f56.svg";